import { definePermisos } from '../utils'

export const RESOURCE_SOLICITUDES = 'Solicitudes' as const
export const permissionTree = definePermisos(RESOURCE_SOLICITUDES, 'solicitudes', {
    transacciones: {
        aprobarSolicitud: 'aprobar-solicitud',
    },
})
